<script setup lang="ts"></script>

<template>
    <RouterView />
</template>

<style>
@import "@quasar/extras/material-icons/material-icons.css";
@import "@quasar/extras/material-icons-outlined/material-icons-outlined.css";
@import "@quasar/extras/material-icons-round/material-icons-round.css";
@import "@quasar/extras/material-symbols-outlined/material-symbols-outlined.css";
@import "@quasar/extras/material-symbols-rounded/material-symbols-rounded.css";
@import "quasar/src/css/index.sass";
@import "vue3-toastify/dist/index.css";
@import "@/common/assets/quasar-overrides.scss";
</style>
